import { StyleSheet } from 'aphrodite';
import { Colors } from '../../themes/Colors';

export const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-lg)*8)',
    backgroundColor: Colors.white,
    height: '100%'
  },

  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    margin:'calc(var(--sp-lg)*1.6) calc(var(--sp-lg)*1.6) 0 calc(var(--sp-lg)*1.6)'
  },

  paymentContainer: {
    padding: "var(--sp-lg)",
    width: "70%",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 10,
    boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.25)",
  },

  activePaymentContainer: {
    width: "70%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 'var(--sp-lg)',
    border:'none'
  },

  couponInput: {
    width: "100%",
    paddingTop: "10px",
    height: "calc(var(--fs-xs)*3.3018)",
  },

 cardsContainer: {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(calc(var(--fs-hero)*8.01886), 1fr))',
  gap: 'calc(var(--sp-md2)*2.2641509)',
  width: '100%',
  alignItems: 'stretch',
}
});
